import { render, staticRenderFns } from "./previous-polls.vue?vue&type=template&id=eebbc82e"
import script from "./previous-polls.vue?vue&type=script&lang=js"
export * from "./previous-polls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports